import React from "react"

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material"

interface ConfirmationDialogProps {
    open: boolean
    title: string
    content: string
    actions: {
        confirmText: string
        cancelText: string
        onConfirm: () => void
        onCancel: () => void
    }
    onClose: () => void
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ open, title, content, actions, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <Typography variant="h6" color="primary">
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" color="text.secondary">
                    {content}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={actions.onCancel} color="secondary">
                    {actions.cancelText}
                </Button>
                <Button onClick={actions.onConfirm} color="primary" autoFocus>
                    {actions.confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmationDialog
